import { Pipe, PipeTransform } from '@angular/core';
import { formatDistance } from 'date-fns';
import { ReviewComment } from './review-types';

@Pipe({
  name: 'commentFromNow',
  standalone: false,
})
export class CommentFromNowPipe implements PipeTransform {
  transform(comment: ReviewComment): string {
    const date = !!comment.published && comment.published > new Date(1970, 0) ? comment.published : comment.created;
    return formatDistance(date, new Date(), { addSuffix: true });
  }
}
